module.exports = __webpack_public_path__ + "img/lights-on-comunicacao.e2639ad3.jpg";